import { useState } from "react";
import { withRouter } from "react-router-dom";
import {
  shiftBurgerOrder,
  pushInBurgerQueue,
  setEndTime,
} from "../../store/ingredient";
import { burgerType } from "../../constants/ingredients";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { get } from "lodash";
import HeaderInfoBox from "../headerInfoBox";

// Images
import speakerIcon from "../../assets/images/speaker.svg";
import Countdown from "react-countdown";
// Styles
import "./styles.scss";
import { MuteSpeaker } from "../../assets/images/svgs";
import { PAUSE_TIMER_EVENT, RESUME_TIMER_EVENT } from "../../constants/const";

function PrimaryHeader(props) {
  const [countPercent, setCountPercent] = useState(100);

  const dispatch = useDispatch();
  const burgerQueue = useSelector((state) =>
    get(state, "ingredients.burgerQueue", [])
  );
  const servingOrder = useSelector((state) =>
    get(state, "ingredients.servingOrder", [])
  );
  const points = useSelector((state) => get(state, "ingredients.points", 0));
  const served = useSelector((state) => get(state, "ingredients.served", 0));

  const totalTime = 3 * 60;

  return (
    <div className="primary-header">
      <div className="row-container">
        <button
          disabled
          className="only-desktop"
          style={{ visibility: "hidden" }}
        >
          &nbsp;&nbsp;&nbsp;&nbsp;
          {/* <button
            className="btn btn-play-tutorial"
            onClick={() => {
              dispatch(resetAll({ isDemo: false }));
              props.history.push("/onboarding");
            }}
          >

            Play Tutorial
          </button> */}
          {/* <img src={closeIcon} className="icon btn" alt="" /> */}
        </button>
        <div className="level-box">
          {/* <div className="title">LEVEL 2</div> */}
          <h4 className="title-lg timer-text">
            {/* {timer} */}
            {
              //!props.isDemo &&

              <Countdown
                date={moment(get(props, "startTime"))
                  .add(3, "minutes")
                  .format()}
                renderer={CountdownRenderer}
                autoStart={true}
                daysInHours={true}
                intervalDelay={1000}
                onTick={(time) => {
                  const timer = time.minutes * 60 + time.seconds;

                  setCountPercent((timer * 100) / totalTime);

                  if (
                    timer % 5 === 0 &&
                    servingOrder.length === 0 &&
                    burgerQueue.length === 0
                  ) {
                    props.history.push("/score");
                    dispatch(setEndTime(moment()));
                  }
                  if (
                    timer % 5 === 0 &&
                    burgerQueue.length < 4 &&
                    servingOrder.length > 0
                  ) {
                    const burgerTypes = servingOrder[0];
                    dispatch(shiftBurgerOrder());
                    dispatch(
                      pushInBurgerQueue({
                        burger: burgerTypes,
                        pushedTime: moment(),
                        expectedEndTime: moment().add(
                          burgerType[burgerTypes].time,
                          "seconds"
                        ),
                      })
                    );
                  }
                }}
                onComplete={() => {
                  props.history.push("/score");
                  dispatch(setEndTime(moment()));
                  // dispatch(resetAll());
                }}
              />
            }
          </h4>
          <div className="timer-bar-header">
            <div className="bar" style={{ width: `${countPercent}%` }}></div>
          </div>
        </div>

        {/* <div> */}
        <button
          disabled
          className="btn-close"
          onClick={() => {
            props.history.push("/score");
            dispatch(setEndTime(moment()));
            // dispatch(resetAll());
          }}
        >
          &nbsp;&nbsp;&nbsp;&nbsp;
          {/* <img src={closeIcon} className="icon" alt="" /> */}
        </button>
        {/* </div> */}

        <button className="btn-speaker" onClick={props.speakerHandler}>
          {props.isAudioMute ? (
            <MuteSpeaker />
          ) : (
            <img src={speakerIcon} className="icon" alt="" />
          )}
        </button>
        <span className="btn-speaker width-32 only-mobile"></span>
      </div>

      <HeaderInfoBox served={served} points={points} />
    </div>
  );
}

export default withRouter(PrimaryHeader);

const CountdownRenderer = ({ hours, minutes, seconds, completed, api }) => {

  const pauseTimer = () => {
    api.pause()
  }

  const resumeTimer = () => {
    api.start()
  }

  window.addEventListener(PAUSE_TIMER_EVENT, pauseTimer)
  window.addEventListener(RESUME_TIMER_EVENT, resumeTimer)

  let mins = minutes;
  let secs = seconds;

  if (completed) {
    return <>Time's Up</>;
  } else {
    if (String(secs).length <= 1) secs = "0" + seconds;
    if (String(mins).length <= 1) mins = "0" + minutes;
    return (
      <span>
        {mins}:{secs}
      </span>
    );
  }
};